import React, { useState, useEffect } from   'react';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import apiService from '../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import { useAuth } from '../../../Auth/AuthContext';
import SeccionPageHeader from '../../Utils/SeccionPageHeader';
import CargandoSpinner from '../../Utils/CargandoSpinner';
import { set } from 'date-fns';

export default function EliminarPersona(){
    const { token, user } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [idPersonaEliminar, setIdPersonaEliminar] = useState('');
    const [idPersonaAsignarAtenciones, setIdPersonaAsignarAtenciones] = useState('');
    const [familia, setFamilia] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10); 
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [swalProps, setSwalProps] = useState({});
    
    useEffect(() => {
    }, []);
    const BuscarPersonaEliminar = async (idPersona) => {
        const url = '/caracterizacion/consultarpersonaseparar';
        const obj = {
            idPersona: idPersona,
        };
        try {
        setCargando(true);
        const response = await apiService.post(url, obj, token);
        const result = await response.data;
        setFamilia(result.integrantes);
        } catch (error) {
            setFamilia([]);
             if(error.status === 422){
                Mensaje('Eliminar', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Eliminar', JSON.stringify(error.response.data));
            }else{
                if (error.response?.data) {
                    Mensaje('Eliminar', JSON.stringify(error.response.data));
                } else {
                    Mensaje('Eliminar', 'Ocurrió un error inesperado.');
                }
            }
            console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    const BuscarFamiliaDestino = async (idJefe) => {
        const url = '/caracterizacion/consultarfamiliadestinoseparar';
        const obj = {
            idJefe: idJefe,
        };
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            setFamiliaDestino(result.integrantes);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    function mensajeSeparar(title, text) {
        return new Promise((resolve) => {
            setSwalProps({
            show: true,
            title: title,
            text: text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'Cancelar',
            preConfirm: () => resolve(true),
            didClose: () => resolve(false),
            });
        });
    }
    async function Eliminar(row){
        const confirmSeparar = await mensajeSeparar("Eliminar persona", `¿Está seguro de que desea eliminar a ${row.nombre}?`);
        if (!confirmSeparar) {
            return;
        }
        setCargando(true);
        const url = '/caracterizacion/eliminarpersona';
        const obj = {
            idPersona: row.per_idpersona,
            idPersonaAtencionesAsignadas: idPersonaAsignarAtenciones,
            usrId: user,
        };
        try {
            const response = await apiService.post(url, obj, token);
            if(response.status === 200){
                BuscarPersonaEliminar(row.gru_idcabezafamilia);
                Mensaje('Eliminar', JSON.stringify(response.data.message));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Eliminar', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Eliminar', JSON.stringify(error.response.data));
            }else{
                if (error.response?.data) {
                    Mensaje('Eliminar', JSON.stringify(error.response.data));
                } else {
                    Mensaje('Eliminar', 'Ocurrió un error inesperado.');
                }
            }
        } finally {
            setCargando(false);
        }
    }    
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    return (
        <div className="content-wrapper">
            <SeccionPageHeader  
                title="Administrar familias - Eliminar persona"
                idCabezaFamilia="1"
                url="/caracterizacion/administrarcaracterizacion"
                nombreurl="Administrar caracterización"
                nombreform=" Eliminar persona"
            />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario eliminar persona</h3>
                            </div>
                            <div className='card-body'>
                                <div className="row">
                                    <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Buscar ID Persona"
                                            value={idPersonaEliminar}
                                            onChange={(e) => setIdPersonaEliminar(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={() => BuscarPersonaEliminar(idPersonaEliminar)}
                                        >
                                            Buscar
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {familia && familia.length > 0 &&
                            <div className="row mt-3">
                                <div className="col-md-12">
                                    <DataTable
                                        columns={[
                                            { name: 'ID Persona', selector: row => row.per_idpersona, sortable: true, width: '150px' },
                                            { name: 'ID Jefe de hogar', selector: row => row.gru_idcabezafamilia, sortable: true, width: '150px' },
                                            { name: 'Nombre', selector: row => row.nombre, sortable: true, width: '250px' },
                                            { name: 'Parentesco', selector: row => row.par_parentesco, sortable: true, width: '200px' },
                                            { name: 'Eliminar', cell: row => (
                                                ((row.par_parentesco !== 'Jefe de Hogar') || 
                                                    (row.par_parentesco === 'Jefe de Hogar' && familia.length <= 1)
                                                ) && 
                                                    (
                                                        <input
                                                            type="checkbox"
                                                            checked={idPersonaEliminar === row.per_idpersona}
                                                            onChange={() => setIdPersonaEliminar(row.per_idpersona)}
                                                        />
                                                    )
                                                ), width: '100px' 
                                            },
                                            { name: 'Acciones', cell: row => (
                                                    ((row.par_parentesco !== 'Jefe de Hogar') || 
                                                        (row.par_parentesco === 'Jefe de Hogar' && familia.length <= 1)
                                                    ) && 
                                                    idPersonaEliminar === row.per_idpersona &&
                                                    (
                                                        <div>
                                                            <select
                                                                className="form-select form-select-sm d-inline-block me-2"
                                                                style={{ width: 'auto' }}
                                                                value={idPersonaAsignarAtenciones}
                                                                onChange={(e) => setIdPersonaAsignarAtenciones(e.target.value)}
                                                                onMouseOver={e => {
                                                                    e.target.title = "Si no elige persona las atenciones se eliminarán";
                                                                }}
                                                            >
                                                                <option value="">Asignar atenciones a...</option>
                                                                {familia
                                                                .filter(f => f.per_idpersona !== row.per_idpersona)
                                                                .map(f => (
                                                                    <option key={f.per_idpersona} value={f.per_idpersona}>
                                                                    {f.per_idpersona}-{f.nombre}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            <button type="button" className="btn btn-sm btn-primary" onClick={() => Eliminar(row)}>
                                                                Eliminar
                                                            </button>
                                                        </div>
                                                    )
                                                ),
                                            },
                                        ]}
                                        data={familia}
                                        pagination
                                        paginationServer
                                        paginationTotalRows={totalRows}
                                        onChangePage={page => setCurrentPage(page)}
                                        onChangeRowsPerPage={newPerPage => setPerPage(newPerPage)}
                                        highlightOnHover
                                        pointerOnHover
                                        noDataComponent="No hay datos para mostrar"
                                    />
                                </div>
                            </div>}                            
                        </div> 
                    
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}